// extracted by mini-css-extract-plugin
export var actionRow = "_mx-6";
export var card = "_mx-0";
export var chevron = "_mx-5";
export var content = "_mx-2";
export var details = "_mx-3";
export var eventActionToggle = "_mx-4";
export var icon = "_mx-1";
export var iconBlue = "_mx-8";
export var iconBrand = "_mx-7";
export var iconGrayBlue = "_mx-9";
export var iconGreen = "_mx-a";
export var iconIndigo = "_mx-b";
export var iconOrange = "_mx-c";
export var iconPurple = "_mx-d";
export var iconRed = "_mx-e";
export var iconWarning = "_mx-f";